"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = require("styled-components");
var _oxygenConfig = require("@8x8/oxygen-config");
var _Avatar = _interopRequireDefault(require("./Avatar"));
var _StyledAvatarStack = _interopRequireDefault(require("../styled/StyledAvatarStack"));
var _excluded = ["children", "maxAvatars", "onClick", "theme", "testId", "avatars"];
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
var noOp = function noOp() {};
var avatarProps = {
  hasBorder: true,
  onClick: null,
  onEdit: noOp,
  showEditOverlay: false,
  size: 'xsmall',
  style: {
    marginLeft: '-16px'
  },
  userStatus: null
};
var formatExtraCountLabel = function formatExtraCountLabel(number) {
  if (number > 99) {
    return '9 9 +';
  }
  return ['+'].concat(String(number).split('')).join(' ');
};
var AvatarStack = function AvatarStack(_ref) {
  var children = _ref.children,
    maxAvatars = _ref.maxAvatars,
    onClick = _ref.onClick,
    theme = _ref.theme,
    testId = _ref.testId,
    avatars = _ref.avatars,
    rest = _objectWithoutProperties(_ref, _excluded);
  // if "avatars" are provided as a prop, all children are ignored and
  // the Avatar components are created from the provided data
  var validItems = avatars || _react["default"].Children.toArray(children).filter(function (_ref2) {
    var type = _ref2.type;
    return type === _Avatar["default"];
  });
  // count to show more than max. remove 1 extra item since that space is taken up by the overflow item
  var extraCount = validItems.length - maxAvatars + 1;
  // if extra count is shown
  var hasExtra = extraCount - 1 > 0;
  // if extra count is shown, remove extra children
  var itemToRender = hasExtra ? validItems.slice(0, maxAvatars - 1) : validItems;
  // if a click event is registered allow the element to be focused
  var stackProps = onClick ? {
    onClick: onClick
  } : {
    as: 'div'
  };
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, /*#__PURE__*/_react["default"].createElement(_StyledAvatarStack["default"], _extends({}, stackProps, (0, _oxygenConfig.getTestAttributes)(testId), rest), itemToRender.map(function (item, index) {
    var props = _objectSpread(_objectSpread(_objectSpread({}, avatarProps), index === 0 && {
      style: {
        marginLeft: '0'
      }
    }), {}, {
      key: index
    });
    if (avatars) {
      // eslint-disable-next-line react/jsx-key
      return /*#__PURE__*/_react["default"].createElement(_Avatar["default"], _extends({}, item, props));
    }
    return /*#__PURE__*/_react["default"].cloneElement(item, props);
  }), hasExtra ? /*#__PURE__*/_react["default"].createElement(_Avatar["default"], _extends({
    name: formatExtraCountLabel(extraCount),
    key: "extra",
    maxInitials: 3
  }, avatarProps, {
    theme: {
      avatarBackgroundColor: theme.counterBackground,
      initialsColor: theme.counterColor
    }
  })) : null));
};
AvatarStack.propTypes = {
  avatars: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    name: _propTypes["default"].string,
    src: _propTypes["default"].string,
    isGroup: _propTypes["default"].bool
  })),
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_Avatar["default"]), _propTypes["default"].objectOf(_Avatar["default"])]),
  maxAvatars: _propTypes["default"].number,
  onClick: _propTypes["default"].func,
  testId: _propTypes["default"].string,
  theme: _propTypes["default"].shape({
    backgroundHover: _propTypes["default"].string,
    borderColorHover: _propTypes["default"].string,
    borderColorFocus: _propTypes["default"].string,
    counterBackground: _propTypes["default"].string,
    counterColor: _propTypes["default"].string
  })
};
AvatarStack.defaultProps = {
  avatars: undefined,
  children: undefined,
  maxAvatars: 4,
  onClick: undefined,
  testId: 'AVATAR_STACK',
  theme: {}
};
var _default = (0, _oxygenConfig.withTheme)(AvatarStack, 'avatarStack');
exports["default"] = _default;